enum LiveblocksUserIdMarker {
  External = 'external',
  ExternalCompact = 'external-compact',
  Internal = 'internal',
  InternalCompact = 'internal-compact',
}

export const parseLiveblocksUser = (liveblocksUserId: string) => {
  const parts = liveblocksUserId.split(':');

  const marker = parts[0];

  // The format marker lives in parts[0] — a fixed system literal, never user-controlled — so it
  // can't collide with legacy's free-text fields (e.g. a commenter's display name in parts[1]).
  if (marker === LiveblocksUserIdMarker.External || marker === LiveblocksUserIdMarker.ExternalCompact) {
    if (marker === LiveblocksUserIdMarker.ExternalCompact) {
      // external-compact:${viewerId} — no name/email embedded, ownership goes through viewerId instead.
      const [, viewerId] = parts;
      return { type: 'external', viewerId, userName: undefined, userEmail: undefined };
    }

    const [, , userEmail] = parts;
    return {
      type: 'external',
      userName: userEmail,
      userEmail,
    };
  }

  if (marker === LiveblocksUserIdMarker.Internal || marker === LiveblocksUserIdMarker.InternalCompact) {
    if (marker === LiveblocksUserIdMarker.InternalCompact) {
      // internal-compact:${userId}:${userUid} — no name/email embedded.
      const [, userId, userUid] = parts;
      return { type: 'internal', userId, userUid, userName: undefined, userEmail: undefined };
    }

    const [, userId, userName, userEmail] = parts;
    return {
      type: 'internal',
      userId,
      userName,
      userEmail,
    };
  }

  throw new Error(`Unknown type: ${marker}`);
};
